import React, { useState, useEffect, useCallback } from 'react';
import CardItem from '../components/CardItem';

export default function Trash() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [emptying, setEmptying] = useState(false);

  const fetchCards = useCallback(async () => {
    setLoading(true);
    const res = await fetch('/api/cards?status=deleted', { credentials: 'include' });
    const data = await res.json();
    setCards(Array.isArray(data) ? data : []);
    setLoading(false);
  }, []);

  useEffect(() => { fetchCards(); }, [fetchCards]);

  const handleAction = async (card, action) => {
    if (action === 'restore') {
      await fetch(`/api/cards/${card.id}`, {
        method: 'PATCH', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'active' })
      });
      fetchCards();
    }
  };

  const handleEmptyTrash = async () => {
    setEmptying(true);
    await fetch('/api/tags/trash', { method: 'DELETE', credentials: 'include' });
    setEmptying(false);
    setShowConfirm(false);
    fetchCards();
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h1>Trash</h1>
          <div className="subtitle">{cards.length} deleted card{cards.length !== 1 ? 's' : ''} — restore or permanently delete</div>
        </div>
        {cards.length > 0 && (
          <button className="btn btn-danger" onClick={() => setShowConfirm(true)}>Empty Trash</button>
        )}
      </div>

      {loading ? <div className="spinner" /> : cards.length === 0 ? (
        <div className="empty-state">
          <div className="icon">—</div>
          <h3>Trash is empty</h3>
          <p>Deleted cards land here before they're gone for good.</p>
        </div>
      ) : (
        <div className="cards-grid">
          {cards.map(card => (
            <CardItem key={card.id} card={card} onAction={handleAction} />
          ))}
        </div>
      )}

      {showConfirm && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Empty trash?</h3>
            <p>This will permanently delete {cards.length} card{cards.length !== 1 ? 's' : ''}. This cannot be undone.</p>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setShowConfirm(false)}>Cancel</button>
              <button className="btn btn-danger" onClick={handleEmptyTrash} disabled={emptying}>
                {emptying ? 'Deleting...' : `Delete ${cards.length} card${cards.length !== 1 ? 's' : ''}`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
